import { assert } from "./common/assertions";
import { platformNotSupportedError } from "./namedErrors";

/**
 * Assert current platform is supported.
 */
export function assertPlatformSupported() {
    const canvas = document.createElement("canvas");
    assert(
        !!canvas.getContext("webgl2") || !!canvas.getContext("webgl"),
        platformNotSupportedError(
            "Camera Kit cannot be bootstrapped because the browser does not support WebGL canvas rendering context."
        )
    );
}
